import CardCollection from './CardCollection';
import * as React from 'react';
import { TxpObject } from 'txp-data';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import TxpStrings from 'txp-data/lib/schema/configSchema/TxpStrings';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import populateViewCards from 'txp-data/lib/utils/view/PopulateViewCards';

export interface TxpProps extends React.HTMLProps<HTMLDivElement> {
    txpStyle: TxpStyle;
    txpStrings: TxpStrings;
    txpObject?: TxpObject;
    calendarEventIds?: any[];
    txpConfiguration: TxpConfiguration;
}

const styles = require('./Txp.scss');
const classNames = require('classnames');

function Txp(props: TxpProps) {
    const {
        txpObject,
        className,
        calendarEventIds,
        txpStyle,
        txpStrings,
        txpConfiguration,
    } = props;

    const viewData = txpObject
        ? populateViewCards(
              txpObject,
              calendarEventIds,
              !!txpConfiguration.getLocationControl,
              txpStrings,
              txpConfiguration.txpImages,
              txpConfiguration.cardRole,
              txpConfiguration.txpDateTimeCallbacks
          )
        : null;

    const cards = viewData ? viewData.cardItems : null;
    const isBusStopEnabled = viewData ? viewData.isBusStopEnabled : null;
    if (cards) {
        return (
            <CardCollection
                className={classNames(className, {
                    [styles.verticalCardCollection]: isBusStopEnabled,
                })}
                cardItems={cards}
                isBusStopEnabled={isBusStopEnabled}
                txpStyle={txpStyle}
                txpConfiguration={txpConfiguration}
                strings={txpStrings.strings}
            />
        );
    } else {
        return null;
    }
}
export default Txp;
